import * as React from 'react';
import {FunctionComponent} from 'react';
import {Modal, Row} from '@flexe/ui-components';
import FlexeButton from '../FlexeButton';

export interface ResetSelectionsProps {
  modalTitle: string;
  modalDetail: JSX.Element;
  showResetSelectionsModal: boolean;
  toggleResetSelectionsModal: () => void;
  resetAllSelections: () => void;
}

const ResetSelectionsModal: FunctionComponent<ResetSelectionsProps> = ({
  modalTitle,
  modalDetail,
  showResetSelectionsModal,
  toggleResetSelectionsModal,
  resetAllSelections
}) => {
  return (
    <Modal title={modalTitle} isOpen={showResetSelectionsModal} toggleModal={toggleResetSelectionsModal}>
      <div id={'reset-cycle-count-list'}>
        <div className={'msg-detail'}>{modalDetail}</div>
        <div className={'buttons'}>
          <Row alignmentHorizontal="end">
            <FlexeButton
              text={'OK'}
              isDisabled={false}
              handleClick={async () => {
                resetAllSelections();
                toggleResetSelectionsModal();
              }}
              level="primary"
            />
          </Row>
        </div>
      </div>
    </Modal>
  );
};

export default ResetSelectionsModal;
